interface IntegrationLogoProps {
  src: string;
  alt: string;
}

export function IntegrationLogo({ src, alt }: IntegrationLogoProps) {
  return (
    <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border bg-white">
      <img src={src} alt={alt} className="h-7 w-7 object-contain" />
    </div>
  );
}
